<div class="upload-container">
    <div class="description">
        {{ 'aumico_reports_companies_upload_logo_description' | i18next }}
    </div>
    <div class="upload-box">
        <div class="logo-container" *ngIf="uploadedLogo">
            <img [src]="uploadedLogo" class="logo" width="100" />
            <span
                hamIconShapes
                class="img-icon"
                icon="assets/hamIcons/close-icon.svg"
                [variant]="'transparent'"
                [size]="'menu'"
                (click)="onRemoveLogo()"
            >
            </span>
        </div>

        <upload
            class="upload-input"
            [acceptedExtensions]="acceptedExtensions"
            [maxSizeInMb]="5"
            (fileUploaded)="onFileUploaded($event)"
            (fileSizeError)="onFileSizeError($event)"
        >
            <div>{{ 'aumico_reports_companies_upload_file_upload_image_info' | i18next }}</div>
            <div>{{ 'aumico_reports_companies_upload_file_upload_image_size' | i18next }}</div>
        </upload>
    </div>
    <div class="file-info" *ngIf="fileMetaData">
        <span class="img-icon ham-icon" icon="assets/hamIcons/image-outline.svg">
            <i class="image-outline-icon"></i>
        </span>
        <div>
            <div class="name">{{ fileMetaData.name }}</div>
            <div class="size">{{ Math.ceil(fileMetaData.size / 1024 / 1024) }} MB</div>
        </div>
        <span class="ham-icon check-circle-green" style="margin-left: auto" icon="assets/hamIcons/check-circle.svg">
            <i class="check-circle"></i>
        </span>
    </div>
    <div *ngIf="fileSizeError" class="file-error">{{ 'aumico_annual_report_file_size_error' | i18next }}</div>
</div>
